
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"15","height":"17","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M6.875 13.018l3.567-3.73-.884-.924-2.683 2.806L5.442 9.67l-.884.924 2.317 2.423z","fill":"#E27CFC"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M11.875 3.596h-1.25V2.29h-1.25v1.307h-3.75V2.29h-1.25v1.307h-1.25c-.69 0-1.25.587-1.25 1.308v9.151c0 .721.56 1.308 1.25 1.308h8.75c.69 0 1.25-.587 1.25-1.308V4.904c0-.721-.56-1.308-1.25-1.308zm.001 10.46H3.125V7.517h8.75l.001 6.537zm0-7.845l-.001-1.307h-8.75V6.21h8.75z","fill":"#E27CFC"}})])
          )
        }
      }
    